import { Dialog } from "@headlessui/react";
import Button from "@lxp-app/components/atoms/button";
import React from "react";

interface DialogProps {
  isShow: boolean;
  // onConfirm: () => void;
  setOpen: (val: boolean) => void;
  buttonName: string;
  heading: string;
  message: string;
  icon?: any;
  onContinue: () => void;
  showContinueButton?: boolean;
}

const MultipleTabConfirmationModal = ({
  isShow,
  // onConfirm,
  buttonName,
  setOpen,
  heading,
  message,
  onContinue,
  icon,
  showContinueButton = true
}: DialogProps) => {
  const closeModal = () => {
    setOpen(false);
  };
  const btnClick = () => {
    setOpen(false);
    onContinue();
  };
  const handleLogout = () => {
    setOpen(false);
    // onConfirm();
  };

  return (
    <>
      <div className=" w-full ">
        <div className="mt-3 text-center sm:mt-0 sm:text-left">
          <div className="my-4 text-base">{message}</div>
        </div>
      </div>
      <div className="mt-5 sm:mt-4 mr-2 flex justify-end space-x-2 md:mb-3 mb-5">
        {showContinueButton && (
          <Button
            label={buttonName}
            variant="contained"
            buttonColor="primary"
            onClick={btnClick}
            testId={`${buttonName?.replace(/\s/g, "")}btn`}
          />
        )}
      </div>
    </>
  );
};

export default MultipleTabConfirmationModal;
